import React from 'react';
import { Link } from 'react-router-dom';
import { shipmentStatusLabel, shipmentStatusBadgeClass, shipmentStatusOptions } from './incomingShipmentStatusUi';
import IncomingStatusBadgePicker from './IncomingStatusBadgePicker';

const IncomingShipmentsDesktopView = ({
  shipments,
  newName,
  setNewName,
  createShipment,
  creating,
  busy = false,
  loading,
  error,
  savingShipmentStatusId,
  onPatchShipmentStatus,
  deletingShipmentId,
  onDeleteShipment
}) => {
  return (
    <>
      <div className='row mt-3'>
        <div className='col-12 p-0'>
          <h3 className='font-weight-bold'>Надходження</h3>
        </div>
      </div>
      <div className='row mb-3'>
        <div className='col-12 col-lg-8 p-0'>
          <div className='input-group'>
            <input
              type='text'
              className='form-control'
              placeholder='Назва надходження, напр. Київ, 20 березня'
              value={newName}
              onChange={(e) => setNewName(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && createShipment()}
              disabled={busy || creating}
            />
            <div className='input-group-append'>
              <button className='btn btn-dark' onClick={createShipment} disabled={busy || creating || !newName.trim()}>
                {creating ? 'Створення...' : 'Створити нове надходження'}
              </button>
            </div>
          </div>
        </div>
      </div>

      {error ? <div className='alert alert-danger'>{error}</div> : null}

      <div className='row'>
        <div className='col-12 p-0'>
          <div className='card'>
            <div className='card-body'>
              {loading ? (
                <div>Завантаження...</div>
              ) : (
                <div className='table-responsive'>
                  <table className='table table-sm'>
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Назва</th>
                        <th>Дата створення</th>
                        <th>Статус</th>
                        <th>К-сть сканів</th>
                        <th />
                      </tr>
                    </thead>
                    <tbody>
                      {shipments.map((r) => (
                        <tr key={r.id}>
                          <td>{r.id}</td>
                          <td>{r.name}</td>
                          <td>{r.createdAt ? new Date(r.createdAt).toLocaleString('uk-UA') : '-'}</td>
                          <td>
                            <IncomingStatusBadgePicker
                              value={r.status || 'draft'}
                              options={shipmentStatusOptions(r.status)}
                              labelOf={shipmentStatusLabel}
                              badgeClassOf={shipmentStatusBadgeClass}
                              onPick={(next) => onPatchShipmentStatus(r.id, next)}
                              disabled={busy || savingShipmentStatusId != null || deletingShipmentId != null || !onPatchShipmentStatus}
                              title='Статус поставки — натисніть, щоб змінити'
                            />
                          </td>
                          <td>{r.itemsCount ?? 0}</td>
                          <td className='text-right'>
                            <Link to={`/admin/incoming-shipments/${r.id}`} className='btn btn-sm btn-outline-dark'>
                              Відкрити
                            </Link>
                            {r.canDelete && <button type='button' className='btn btn-sm btn-outline-danger ml-2'
                              disabled={busy || deletingShipmentId != null || savingShipmentStatusId != null || !onDeleteShipment}
                              onClick={() => onDeleteShipment(r)} aria-label={`Видалити поставку #${r.id}`}>
                              {deletingShipmentId === r.id ? 'Видалення…' : 'Видалити'}
                            </button>}
                          </td>
                        </tr>
                      ))}
                      {!shipments.length ? (
                        <tr>
                          <td colSpan={6} className='text-muted'>Надходжень ще немає</td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default IncomingShipmentsDesktopView;
